import { render, staticRenderFns } from "./bFeedbackView_mulilang.vue?vue&type=template&id=0aaba1ac&scoped=true"
import script from "./bFeedbackView_mulilang.vue?vue&type=script&lang=js"
export * from "./bFeedbackView_mulilang.vue?vue&type=script&lang=js"
import style0 from "./bFeedbackView_mulilang.vue?vue&type=style&index=0&id=0aaba1ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaba1ac",
  null
  
)

export default component.exports